(function () {
  function slugify(text) {
    return (text || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^\w\u4e00-\u9fff]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getHeadingLabel(heading) {
    return (heading.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function ensureHeadingId(heading, index, sectionId, usedIds) {
    if (heading.id) {
      usedIds.add(heading.id);
      return heading.id;
    }

    var base = slugify(getHeadingLabel(heading)) || sectionId + '-heading-' + index;
    var id = base;
    var suffix = 1;

    while (!id || usedIds.has(id) || document.getElementById(id)) {
      id = base + '-' + suffix;
      suffix += 1;
    }

    heading.id = id;
    usedIds.add(id);
    return id;
  }

  function bindTocPairs(pairs) {
    pairs.forEach(function (pair) {
      pair.link.addEventListener('click', function (event) {
        event.preventDefault();
        pair.heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        pairs.forEach(function (p) {
          p.link.classList.remove('is-active');
        });
        pair.link.classList.add('is-active');
        if (history.replaceState) {
          history.replaceState(null, '', '#' + pair.heading.id);
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var visible = entries
            .filter(function (entry) {
              return entry.isIntersecting;
            })
            .sort(function (a, b) {
              return b.intersectionRatio - a.intersectionRatio;
            });

          if (!visible.length) return;

          var activeId = visible[0].target.id;
          pairs.forEach(function (pair) {
            pair.link.classList.toggle('is-active', pair.heading.id === activeId);
          });
        },
        {
          root: null,
          rootMargin: '-20% 0px -60% 0px',
          threshold: [0, 0.25, 0.5, 1]
        }
      );

      pairs.forEach(function (pair) {
        observer.observe(pair.heading);
      });
    } else if (pairs[0]) {
      pairs[0].link.classList.add('is-active');
    }
  }

  function initShow5Toc(root) {
    var content = root.querySelector('[data-mt-show5-content]');
    var list = root.querySelector('[data-mt-show5-toc-list]');
    var aside = root.querySelector('[data-mt-show5-toc-aside]');
    if (!content || !list || !aside) return;

    var headings = Array.from(content.querySelectorAll('h2'));

    if (!headings.length) {
      aside.hidden = true;
      root.classList.remove('mt-block-show5--with-toc');
      return;
    }

    aside.hidden = false;
    root.classList.add('mt-block-show5--with-toc');

    var sectionId = root.getAttribute('data-section-id') || 'show5';
    var usedIds = new Set();
    var pairs = [];

    list.innerHTML = '';

    headings.forEach(function (heading, index) {
      var label = getHeadingLabel(heading);
      if (!label) return;

      var anchorId = ensureHeadingId(heading, index, sectionId, usedIds);
      var item = document.createElement('li');
      item.className = 'mt-block-show5-toc-item';

      var link = document.createElement('a');
      link.className = 'mt-block-show5-toc-link';
      link.setAttribute('data-mt-show5-toc-link', '');
      link.href = '#' + anchorId;
      link.textContent = label;

      item.appendChild(link);
      list.appendChild(item);
      pairs.push({ link: link, heading: heading });
    });

    if (!pairs.length) {
      aside.hidden = true;
      root.classList.remove('mt-block-show5--with-toc');
      return;
    }

    bindTocPairs(pairs);

    if (window.location.hash) {
      var target = content.querySelector(window.location.hash);
      if (target) {
        setTimeout(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }

  document.querySelectorAll('[data-mt-show5]').forEach(initShow5Toc);
})();
